/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommonBannedAsinResponseDTOFromJSON, CommonBannedAsinResponseDTOToJSON, } from './CommonBannedAsinResponseDTO';
/**
 * Check if a given object implements the PaginatedResponseCommonBannedAsinResponseDTO interface.
 */
export function instanceOfPaginatedResponseCommonBannedAsinResponseDTO(value) {
    return true;
}
export function PaginatedResponseCommonBannedAsinResponseDTOFromJSON(json) {
    return PaginatedResponseCommonBannedAsinResponseDTOFromJSONTyped(json, false);
}
export function PaginatedResponseCommonBannedAsinResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(CommonBannedAsinResponseDTOFromJSON)),
    };
}
export function PaginatedResponseCommonBannedAsinResponseDTOToJSON(json) {
    return PaginatedResponseCommonBannedAsinResponseDTOToJSONTyped(json, false);
}
export function PaginatedResponseCommonBannedAsinResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(CommonBannedAsinResponseDTOToJSON)),
    };
}
